import PropTypes from 'prop-types'
import React from 'react'
import { shouldShowCheckBox } from '../customColumns'

export const TableRow = ({ row, isSelectable, validateSelectable }) => {
  return (
    <tr key={row.id} {...row.getRowProps()}>
      {row.cells.map((cell) =>
        shouldShowCheckBox(cell.column, isSelectable) ? (
          <td
            {...cell.getCellProps()}
            style={{
              padding: '2px',
              boxShadow:
                'inset -1px 0px 0px #D7D7D7, inset 0px -1px 0px #D7D7D7',
              textAlign: 'left',
              height: '20px',
            }}
          >
            {cell.render('Cell', { validateSelectable, row })}
          </td>
        ) : null,
      )}
    </tr>
  )
}
TableRow.displayName = 'TableRow'
TableRow.propTypes = {
  isSelectable: PropTypes.bool,
  row: PropTypes.object,
  validateSelectable: PropTypes.func,
}
const TableBody = ({
  getTableBodyProps,
  prepareRow,
  rows,
  isSelectable,
  validateSelectable,
}) => {
  return (
    <tbody {...getTableBodyProps()}>
      {rows.map((row) => {
        prepareRow(row)
        return (
          <TableRow
            row={row}
            isSelectable={isSelectable}
            key={row.id}
            validateSelectable={validateSelectable}
          />
        )
      })}
    </tbody>
  )
}

TableBody.propTypes = {
  getTableBodyProps: PropTypes.func,
  isSelectable: PropTypes.bool,
  prepareRow: PropTypes.func,
  rows: PropTypes.array,
  validateSelectable: PropTypes.func,
}

export default TableBody
